import React from "react";

import {
  FiArrowLeft,
  FiChevronRight,
  FiSmartphone,
  FiHome,
  FiUpload,
} from "react-icons/fi";

const BankAccountPage = ({
  selectedBankId,
  getBank,
  setScreen,
}) => {
  const selectedBank = getBank(selectedBankId);

  return (
    <section className="fw-screen fw-screen--bank fw-fade">
      <div className="fw-bank-top">
        <button
          type="button"
          className="fw-bank-back"
          onClick={() => setScreen("/apply-new/selectBank")}
          aria-label="Back"
        >
          <FiArrowLeft />
        </button>

        <h1>Connect your Bank testd</h1>
      </div>

      <div className="fw-bank-chip fw-bank-chip--selected">
        <span
          className="fw-bank-logo fw-bank-logo--sm"
          style={{ background: selectedBank.color }}
        >
          {selectedBank.name.charAt(0)}
        </span>

        <strong>{selectedBank.name}</strong>
      </div>

      <div className="fw-connect-list">

        {/* Fetch Using Phone Number */}
        <button
          type="button"
          className="fw-connect-card fw-connect-card--featured"
          onClick={() => setScreen("/apply-new/aaMobile")}
        >
          <span className="fw-connect-card__badge">
            Fast, Secure &amp; Recommended
          </span>

          <span
            className="fw-connect-card__icon"
            aria-hidden="true"
          >
            <FiSmartphone />
          </span>

          <div className="fw-connect-card__body">
            <strong>Fetch Using Phone Number</strong>

            <p>
              Securely retrieve your bank details using your
              registered mobile number through an RBI regulated
              Account Aggregator.
            </p>
          </div>

          <FiChevronRight
            className="fw-connect-card__arrow"
            aria-hidden="true"
          />
        </button>

        {/* Net Banking */}
        <button
          type="button"
          className="fw-connect-card"
          onClick={() => setScreen("aaMobile")}
        >
          <span
            className="fw-connect-card__icon"
            aria-hidden="true"
          >
            <FiHome />
          </span>

          <div className="fw-connect-card__body">
            <strong>Net Banking</strong>

            <p>
              Conveniently connect by logging in with your
              Internet Banking User ID and Password.
            </p>
          </div>

          <FiChevronRight
            className="fw-connect-card__arrow"
            aria-hidden="true"
          />
        </button>

        {/* Upload Statement */}
        <button
          type="button"
          className="fw-connect-card"
          onClick={() => setScreen("aaMobile")}
        >
          <span
            className="fw-connect-card__icon"
            aria-hidden="true"
          >
            <FiUpload />
          </span>

          <div className="fw-connect-card__body">
            <strong>Upload Statement</strong>

            <p>
              Easily upload your official bank statement
              document for verification.
            </p>
          </div>

          <FiChevronRight
            className="fw-connect-card__arrow"
            aria-hidden="true"
          />
        </button>

      </div>

      <p className="fw-powered">
        Powered by <b>FUNDSWALLE</b>
      </p>
    </section>
  );
};

export default BankAccountPage;